<template>
  <section class="town" :data-scene="scene">
    <div class="town__inner">
      <div class="town__wrapper">
        <div class="town__section town__section--1">
          <transition name="scenefade">
            <Friends v-if="scene === 'friends'" />
          </transition>
        </div>
        <div class="town__section town__section--2">
          <transition name="scenefade">
            <VillageFriends v-if="scene === 'village' || scene === 'friends'" />
          </transition>
        </div>
        <div class="town__section town__section--3">
          <transition name="scenefade">
            <Village v-if="scene === 'village'" />
          </transition>
        </div>
        <div class="town__section town__section--4">
          <transition name="scenefade">
            <VillageWorld v-if="scene === 'village' || scene === 'world'" />
          </transition>
        </div>
        <div class="town__section town__section--5">
          <transition name="scenefade">
            <World v-if="scene === 'world'" />
          </transition>
        </div>
        <!-- background -->
        <div class="floor" />
        <!-- house -->
        <picture>
          <source
            srcset="@/assets/images/village/house.webp 700w"
            type="image/webp"
            sizes="500px"
          >
          <img
            class="house"
            alt="House"
            src="@/assets/images/village/house.png"
            srcset="@/assets/images/village/house.png 700w"
            width="581"
            height="287"
            sizes="500px"
          >
        </picture>
        <!-- hall -->
        <picture>
          <source
            srcset="@/assets/images/village/hall.webp 700w"
            type="image/webp"
            sizes="500px"
          >
          <img
            class="hall"
            alt="Hall"
            src="@/assets/images/village/hall.png"
            srcset="@/assets/images/village/hall.png 700w"
            width="802"
            height="708"
            sizes="500px"
          >
        </picture>
      </div>
    </div>
  </section>
</template>

<script>
import Village from '@/components/screens/town/Village.vue'
import Friends from '@/components/screens/town/Friends.vue'
import World from '@/components/screens/town/World.vue'

import VillageFriends from '@/components/screens/town/VillageFriends.vue'
import VillageWorld from '@/components/screens/town/VillageWorld.vue'

export default {
  name: 'Ground',

  props: {
    scene: {
      default: () => '',
      type: String
    }
  },

  components: {
    Village,
    Friends,
    World,
    VillageFriends,
    VillageWorld
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/landing/mixins.scss';

.town,
.town__inner {
  position: absolute;
  z-index: 0;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.town__wrapper {
  position: absolute;
  z-index: 0;
  top: 0;
  left: 0;
  height: 100%;
  display: flex;
  flex-direction: row;
  transform: translate3d(-200vw, 0, 0);
  transition: transform 3s ease;

  @include breakpoint(sm) {
    transform: translate3d(-150vw, 0, 0);
  }

  .resizing & {
    transition: none;
  }
}
.town[data-scene="friends"] .town__wrapper {
  transform: translate3d(0, 0, 0);
}
.town[data-scene="village"] .town__wrapper {
  transform: translate3d(-200vw, 0, 0);

  @include breakpoint(sm) {
    transform: translate3d(-150vw, 0, 0);
  }
}
.town[data-scene="world"] .town__wrapper {
  transform: translate3d(-400vw, 0, 0);

  @include breakpoint(sm) {
    transform: translate3d(-300vw, 0, 0);
  }
  @include breakpoint(xl) {
    transform: translate3d(-280vw, 0, 0);
  }
}
.town__section {
  position: relative;
  z-index: 2;
  width: 100vw;
  height: 100%;
}
.town__section--2 {
  width: 100vw;

  @include breakpoint(sm) {
    width: 50vw;
  }
}
.town__section--4 {
  width: 100vw;

  @include breakpoint(sm) {
    width: 50vw;
  }
  @include breakpoint(xl) {
    width: 30vw;
  }
}
.floor {
  position: absolute;
  z-index: 1;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100px;
  background-image: url('../../assets/images/village/flooring.png');
  background-position: top left;
  background-repeat: repeat-x;
  background-size: auto 236px;
}
.house {
  position: absolute;
  z-index: 0;
  bottom: 80px;
  left: 130vw;
  width: 500px;
  height: auto;

  @include breakpoint(sm) {
    left: 150vw;
    width: 600px;
  }
  @include breakpoint(lg) {
    width: 800px;
  }
}
.hall {
  position: absolute;
  z-index: 0;
  bottom: 80px;
  left: 280vw;
  width: 600px;
  height: auto;

  @include breakpoint(sm) {
    left: 240vw;
  }
  @include breakpoint(lg) {
    left: 240vw;
    width: 1000px;
  }
}

:deep(.arrow) {
  @media(min-width: 768px) and (min-height: 600px) {
    font-size: 2rem;
    .arrow__circle {
      width: 70px;
      height: 70px;
      svg {
        width: 30px;
        height: 30px;
      }
    }
    .arrow__speach {
      height: 50px;
      margin-top: 10px;
      border-width: 2px;
    }
    &.arrow--left, &.arrow--right {
      .arrow__speach {
        &:after {
          top: 15.5px;
        }
      }
    }
  
    &.arrow--down {
      .arrow__speach {
        &:after {
          border-right-width: 2px;
          border-bottom-width: 2px;
          bottom: -9.2px;
        }
      }
    }
    
    &.arrow--left {
      .arrow__speach {
        &:after {
          border-left-width: 2px;
          border-bottom-width: 2px;
          left: -9.2px;
        }
      }
    }
    
    &.arrow--right {
      .arrow__speach {
        &:after {
          border-right-width: 2px;
          border-top-width: 2px;
          right: -9.2px;
        }
      }
    }
  }
} 

@media only screen and (max-height: 440px) and (orientation: landscape) {
  .floor {
    height: 70px;
  }
  .house, .hall{
    bottom: 50px;
  }
}
</style>
